import { get, ApiBase } from '@ssr/api/request'

function getManuals(query) {
  const x_language = window.locale === 'zh-cn' ? 'zh-cn' : 'en-us'
  const postQuery = {
    'X-Language': x_language,
    page_size: 99,
    ...query,
  }

  return get(`${ApiBase.communityService}/community/v2/tutorial/getManuals`, postQuery)
}

function getBanners(query) {
  const x_language = window.locale === 'zh-cn' ? 'zh-cn' : 'en-us'
  const postQuery = {
    'X-Language': x_language,
    ...query,
  }

  return get(`${ApiBase.communityService}/community/v1/banner`, postQuery)
}

function getTutorialCategory(query) {
  const x_language = window.locale === 'zh-cn' ? 'zh-cn' : 'en-us'
  const postQuery = {
    'X-Language': x_language,
    ...query,
  }

  return get(`${ApiBase.communityService}/community/v2/tutorial/getTutorialCategory`, postQuery)
}

function getTutorialItems(query) {
  const x_language = window.locale === 'zh-cn' ? 'zh-cn' : 'en-us'
  const postQuery = {
    'X-Language': x_language,
    page_size: 99,
    ...query,
  }

  return get(`${ApiBase.communityService}/community/v2/tutorial/getTutorialItems`, postQuery)
}

export default {
  getManuals,
  getBanners,
  getTutorialCategory,
  getTutorialItems,
}
